import { renderRegisterlayer } from '@liepin/react-login4c-pc';

renderRegisterlayer()
